/*
 * @Author: Zhushitao
 * @Date: 2021-04-09 17:34:43
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-10-27 10:18:50
 * @Description: Message default middleware
 */
import { AnyAsyncFunction } from './type';

export async function uniqueId(ctx: any, next: AnyAsyncFunction) {
  ctx.message._id = ctx.message.clientId || ctx.message.serverId;
  await next();
}

export async function userConfig(ctx: any, next: AnyAsyncFunction) {
  if (!ctx.message?.user) {
    ctx.message.user = {};
  }
  await next();
}
